// extracted by mini-css-extract-plugin
module.exports = {"select":"_2PJw2PZiTeYOsbFEvSU5Db"};